"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
export default function BrandCoreVision() {
  return <section data-section-id="104912" id="聽力新生活首頁" className="dark bg-background text-foreground relative h-[50vh] min-h-[300px] w-full overflow-hidden flex items-center">
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes fadeInUp {
          from { transform: translateY(50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slide-in-right {
          animation: slideInRight 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .animate-fade-in-up {
          animation: fadeInUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
        }
      `}</style>

      {}

      {}
      <div className="absolute inset-0 bg-gradient-to-r from-secondary/90 via-secondary/40 to-transparent z-10 pointer-events-none" />

      {}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-6 md:px-8 flex flex-col justify-center">
        <div className="max-w-4xl">
          <h1 className="animate-slide-in-right text-4xl md:text-[56px] font-bold text-white leading-tight tracking-tight">
            聽見生命的律動，重拾生活的色彩
          </h1>
          <p className="animate-fade-in-up mt-6 text-lg md:text-xl text-white/90 max-w-2xl leading-relaxed [animation-delay:200ms]">瑞聲助聽器醫材在全台共有100+的聯盟聽力中心，提供專業的聽力評估與助聽器選配服務。請告知我們您所在的區域，我們將盡快為您安排最近的專業服務點，讓您重拾清晰聽力。<br />※ 本站為 INTERTON 助聽器經銷商,非原廠官方網站</p>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 md:right-8 z-30 flex flex-col items-center gap-8">
        <div className="flex flex-col items-center animate-bounce text-white/90">
          <ChevronDown className="size-8 -mb-4 opacity-50" />
          <ChevronDown className="size-8" />
          <span className="text-xs font-bold mt-2 tracking-widest uppercase opacity-80">安心購</span>
        </div>
      </div>
    </section>;
}